import { useEffect, useState } from "react";
import QRCode from "qrcode";

interface QrSvgProps {
  text: string;
  margin?: number;
  className?: string;
  "aria-label"?: string;
}

/**
 * QR rendered as SVG for crisp print (ticket 08/09).
 *
 * The `qrcode` package is imported statically — the old `require("qrcode/lib")`
 * worked under Vitest's CJS interop but threw `require is not defined` in the
 * Vite browser bundle, leaving the label preview dialog blank.
 */
export function QrSvg({ text, margin = 1, className, "aria-label": ariaLabel }: QrSvgProps) {
  const [svg, setSvg] = useState<string>("");

  useEffect(() => {
    let active = true;
    if (!text) {
      setSvg("");
      return;
    }
    QRCode.toString(text, { type: "svg", errorCorrectionLevel: "M", margin })
      .then((value) => {
        if (active) setSvg(value);
      })
      .catch(() => {
        if (active) setSvg("");
      });
    return () => {
      active = false;
    };
  }, [text, margin]);

  if (!svg) {
    return (
      <div
        data-testid="qr-svg"
        aria-label={ariaLabel ?? "QR"}
        style={{ width: "100%", height: "100%" }}
      />
    );
  }
  return (
    <div
      className={className}
      data-testid="qr-svg"
      aria-label={ariaLabel ?? (text ? `QR ${text}` : "QR")}
      style={{ width: "100%", height: "100%", lineHeight: 0 }}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
